// The reCAPTCHA site key is public, but it has a single source of truth:
// Rails credentials (recaptcha.site_key). The public layout renders it into a
// <meta name="recaptcha-site-key"> tag, and this reads it back, so the value is
// no longer duplicated across the layout and every form that uses it.
export function recaptchaSiteKey() {
  const meta = document.querySelector('meta[name="recaptcha-site-key"]');
  return meta ? meta.getAttribute('content') : '';
}

// Password-reset pages deliberately omit third-party scripts while the token is
// still in the URL. This loads reCAPTCHA from its fixed trusted origin only
// after the component has removed that credential from browser history.
export function loadRecaptcha() {
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);

  const existingLoader = document.querySelector('script[data-recaptcha-loader]');
  if (existingLoader) {
    return new Promise((resolve, reject) => {
      existingLoader.addEventListener('load', () => resolve(window.grecaptcha), { once: true });
      existingLoader.addEventListener('error', reject, { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const loader = document.createElement('script');
    loader.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(recaptchaSiteKey())}`;
    loader.async = true;
    loader.dataset.recaptchaLoader = 'true';
    loader.addEventListener('load', () => resolve(window.grecaptcha), { once: true });
    loader.addEventListener('error', reject, { once: true });
    document.head.appendChild(loader);
  });
}

// The badge is removed after a successful submit. It is not always there: an ad
// blocker, a privacy extension or a blocked Google can stop the loader from ever
// rendering it. Calling .remove() on the missing element used to throw, and
// because that happened immediately before the redirect, the user ended up
// signed in on the server but stranded on the form.
export function removeRecaptchaBadge() {
  const badge = document.getElementsByClassName('grecaptcha-badge')[0];
  if (badge) badge.remove();
}
